/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IICD10Diagnosis } from 'app/shared/model/icd-10-diagnosis.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IChronicCondition {
  id?: string;
  category?: string;
  subCategory?: string;
  active?: boolean | null;
  microSec?: number | null;
  lastupdated?: number | null;
  timestampentry?: number | null;
  cursor?: number;
  snomedConceptId?: string | null;
  snomedConceptText?: string | null;
  topographyStart?: number | null;
  topographyEnd?: number | null;
  std?: boolean | null;
  diagnosis?: IICD10Diagnosis | null;
  topography?: IClinicalDictionary | null;
  morphologyGroup?: IClinicalDictionary | null;
  morphology?: IClinicalDictionary | null;
  behaviour?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IChronicCondition> = {
  active: false,
  std: false,
};
